import React from "react";
const LOGO_URL = "https://cdn.magicpatterns.com/uploads/ey7t78L7kbQvqY81egZpuN/big-yellow-logo.png";
const footerLinks = [{
  label: "Current vacancies",
  href: "https://bigyellow.au/careers/"
}, {
  label: "Life at Big Yellow",
  href: "#life"
}, {
  label: "Community",
  href: "#community"
}, {
  label: "Services & projects",
  href: "https://bigyellow.au/our-services/"
}, {
  label: "Our fleet",
  href: "https://bigyellow.au/our-fleet/"
}, {
  label: "About Big Yellow",
  href: "https://bigyellow.au/about-us/"
}];
const linkClass = "inline-flex min-h-8 items-center transition-colors duration-150 hover:text-[#FFCF53]";
export function SiteFooter() {
  return <footer className="bg-black pb-24 text-white md:pb-0" data-id="element-335" data-mp="wocveumeuyrb">
      <div className="mx-auto w-full max-w-[1600px] px-6 py-16 lg:px-12 xl:px-20" data-id="element-336" data-mp="11hnzinzu91fj">
        <div className="grid gap-12 border-b border-white/15 pb-12 sm:grid-cols-2 lg:grid-cols-12" data-id="element-337" data-mp="40gzvt8kvcw4">
          <div className="lg:col-span-4" data-id="element-338" data-mp="8zjuskuug2qd">
            <img src={LOGO_URL} alt="Big Yellow" width={188} height={102} className="h-auto w-[200px]" data-id="element-339" data-mp="8y8p2fhu8kwm" />
            <p className="mt-6 max-w-xs text-base leading-7 text-white/70" data-id="element-340" data-mp="aoy4pkfl4fh2">Mining services. People and culture. Western Australia.</p>
            <p className="mt-5 inline-block border border-[#FFCF53]/60 px-3 py-2 text-sm font-medium text-[#FFCF53]" data-id="element-341" data-mp="1u09u7svmsn3">Design concept · review mode</p>
          </div>
          <div className="lg:col-span-3 lg:col-start-7" data-id="element-342" data-mp="3sza2664cfizv">
            <p className="text-base font-semibold" data-id="element-343" data-mp="3o2t3ihzipm8j">Explore Big Yellow</p>
            <nav aria-label="Footer navigation" className="mt-4 flex flex-col gap-1.5 text-base text-white/75" data-id="element-344" data-mp="3j2f4fpfw9mmn">
              {footerLinks.map(link => <a key={link.label} href={link.href} className={linkClass} data-id="element-345" data-mp="3f3fwdvyv99qz">{link.label}</a>)}
            </nav>
          </div>
          <address className="not-italic lg:col-span-3" data-id="element-346" data-mp="1dai4c2cwyl73">
            <p className="text-base font-semibold" data-id="element-347" data-mp="1d7vxy61rebqg">Contact our office</p>
            <div className="mt-4 space-y-2 text-base leading-7 text-white/75" data-id="element-348" data-mp="18bf18nghup1r">
              <p data-id="element-349" data-mp="1refrzvtalbj8"><a href="tel:+61862634753" className={linkClass} data-id="element-350" data-mp="1refrlupdr9ip">(08) 6263 4753</a></p>
              <p data-id="element-351" data-mp="1w6h158v5ym51"><a href="mailto:admin@bigyellow.au" className={linkClass} data-id="element-352" data-mp="1w6gz73blsc2e">admin@bigyellow.au</a></p>
              <p data-id="element-353" data-mp="1iflodlhjnkw6">63 Dowd Street<br data-id="element-354" data-mp="1ig3t76i9v7fp" />Welshpool WA 6106</p>
              <p className="text-white/60" data-id="element-355" data-mp="1iczgfkqqr3df">Monday to Friday, 8:00am–5:00pm</p>
            </div>
          </address>
        </div>
        <div className="flex flex-col gap-3 pt-7 text-sm text-white/55 sm:flex-row sm:justify-between" data-id="element-356" data-mp="2b2ybbwrm9uq0">
          <p data-id="element-357" data-mp="2f5l728rerzsh">Prototype only. No candidate information is sent or stored.</p>
          <p data-id="element-358" data-mp="215agz7xxap8d">Legal and privacy links require client approval before production.</p>
        </div>
      </div>
    </footer>;
}